import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import App from './App';
import { theme } from './theme';
import { getAuthConfig } from './api/businessPortalApi';
import { msalConfig } from './authConfig';

const QueryClientProviderContext: React.FC<{
    children: React.ReactNode;
}> = ({ children }) => {
    const queryClient = React.useMemo(
        () =>
            new QueryClient({
                defaultOptions: {
                    queries: {
                        refetchOnMount: false,
                        refetchOnWindowFocus: false,
                        retryOnMount: false,
                        retry: false,
                        staleTime: 3600000, // 1 hour
                    },
                },
            }),
        []
    );

    return (
        <QueryClientProvider client={queryClient}>
            {children}
        </QueryClientProvider>
    );
};

getAuthConfig().then((authConfig) => {
    if (authConfig) {
        const config = msalConfig(
            authConfig.clientId,
            authConfig.redirectUri,
            authConfig.tenant
        );

        const msalInstance = new PublicClientApplication(config);

        ReactDOM.createRoot(document.getElementById('root')!).render(
            <ChakraProvider theme={theme}>
                <QueryClientProviderContext>
                    <MsalProvider instance={msalInstance}>
                        <App
                            scopes={authConfig.scopes}
                            disableB2CAuth={
                                process.env.REACT_APP_DISABLE_B2C_AUTH ===
                                'true'
                            }
                        />
                    </MsalProvider>
                </QueryClientProviderContext>
            </ChakraProvider>
        );
    }
});
